import React, { useEffect, useLayoutEffect, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPOSStatus, drawPrice, istl, requestPrompt } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import ISBNSearch from "./pos/ISBNSearch";
import { createModal } from "../hooks/createModal";
import Nav from "../ui/Nav";
import { apiCall } from "../utils/Api";
import { TRANSACTION_ITEM } from "../utils/Struct";

export default function POSItems(props) {

    const {
        employee = "",
        controller = "",
        signal = {},
        loading = false,
        setLoading = () => { },
        header = {},
        route = "",
        align = "auto",
        setAlign = () => { },
        state = {},
        setState = () => { },
        cancelEdit = () => { },
    } = props;

    const row_key = "pos_id"

    const buffer = 20;

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({})


    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }


    const fetchItems = () => {
        // pos_id - for remembering...
        if (state.view !== "items") return;

        if(!header?.invoice){
            return; 
        }

        setLoading(true);
        pubCall("point_of_sale.getInitialItem", { sort: "id", invoice: header?.invoice, limit: 40 }, (_s, _r) => {
            if (_s) {
                setData(_r.rows_next);
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})

            }
            setLoading(false)
        })
    }

    useEffect(fetchItems, [state.view, header]);

    const searchISBN = (_search) => {
        window.bm_state.value = ROUTES.POS.SEARCH_ISBN;
        createModal({
            component: <ISBNSearch
                controller={controller}
                search={_search} route={ROUTES.POS.SEARCH_ISBN} />,
            closable: true,
            title: "Select Item (Multiple Matches)",
            callback: () => { window.bm_state.value = ROUTES.POS.CUSTOMER; }
        })
    }


    const addItem = (_isbn = "", _force = false) => {


        blurField(); 

        if (!_isbn) {
            return;
        }
        const is_new = (!selected?.acr_id);

        // check to see if isbn is less than 13 chars (can be more)
        if (_isbn?.length < 13 && !_force) {
            // search ISBN then feed back selection with force
            searchISBN();
            return;
        }

        if (is_new) {
            
            
            // pass header too
            pubCall("point_of_sale.startNewTransaction", {header : header.header, item : {...TRANSACTION_ITEM, "primary_code" : _isbn}, check_onhands : true, clerk_code: employee}, (_s, _r) => {
                if(_s){
                    console.log(_r);
                } else {

                }
            })
        }



    }



    const canEditRow = (_row) => {
        if (!_row?.pos_id && window.bm_state.value === ROUTES.POS.EDIT && state?.adding) {
            return true;
        } else {
            return false;
        }
    }

    const defaultTabs = [
        { label: "cust_po", key: "cust_po", value: "cust_po" },
        { label: "primary_code", key: "primary_code", value: "primary_code" },
        { label: "quantity", key: "quantity", value: "quantity" },
        { label: "price", key: "price", value: "price" },
        { label: "discount", key: "discount", value: "discount" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "primary_code");


    useLayoutEffect(() => {
        if (!state.edit) return;

        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });

    }, [index, state.edit]);

    useLayoutEffect(() => {
        if (!state.edit) return;

        requestAnimationFrame(() => {
            const el = refs?.current["primary_code"];
            if (el) el.focus();
        });

    }, [window.bm_state.value]);

    useEffect(() => { })

    const switchToCustomer = () => {
        setState({ ...state, "view": "customer" })
        window.bm_state.value = ROUTES.POS.CUSTOMER;
    }

    const switchToTransaction = () => {
        setState({ ...state, "view": "items" })
        window.bm_state.value = ROUTES.POS.EDIT;
    }


    const testIt = (item) => {
        requestPrompt({
            route: ROUTES.POS.POS, title: "Tobias Testing stuff..", inputProps: { style: { "textAlign": "left" } }, callback: (_s) => {

                let _itm = { ...item, "quantity": parseInt(_s) || 0 };
                pubCall("point_of_sale.editItem", { item: _itm }, (_s, _r) => {
                    if (_s) {
                        console.log(_r);

                    } else {
                        console.log(_r);
                        showError(_r);
                    }
                })

            }
        })

    }

    useEffect(() => {


        const actions = (state.adding) ? pos_new_nav : pos_edit_nav;

        const cleanup = listen(controller, ROUTES.POS.EDIT, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE]);
        return cleanup;
    }, [index, tabs, refs, state.adding])

    const columns = [
        { min: true, width: 50, key: "available_onhand", align: "right", title: <>aOH</> },
        { min: true, width: 130, key: "class", align: "left", title: <>Class</> },
        { min: true, width: 100, grow: true, key: "title", align: "left", title: <>Title</> },
        {
            min: true, width: 130, key: "cust_po", align: "left", title: <>CustPo</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input {...editProps("cust_po")} edit={state.edit} width={110} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 150, key: "primary_code", align: "left", title: <>ISBN</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input {...editProps("primary_code")} onEnter={(_value) => addItem(_value)} edit={state.edit} width={140} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 50, key: "quantity", align: "left", title: <>Qty</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input {...editProps("quantity")} edit={state.edit} width={30} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 80, key: "price", align: "right", title: <>price</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input {...editProps("price")} edit={state.edit} width={60} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 40, key: "discount", align: "right", title: <>%</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input {...editProps("discount")} edit={state.edit} width={22} /></>
                } else {
                    return e
                }
            }
        },
        { min: true, width: 50, key: "tax_code", align: "right", title: <>Tax</> },
        { min: true, width: 50, key: "points", align: "right", title: <>Pts</> },
        { min: true, width: 80, key: "total_price", align: "left", title: <>Total</> },
        { min: true, width: 90, key: "prepay_status", align: "left", title: <>PPY</> },
    ];





    const nextItem = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prevItem = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };


    const pos_new_nav = [

        { key: KBD.ESCAPE, action: () => cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT) },
        { key: KBD.ARROW_DOWN, action: () => { next() } },

        {
            key: KBD.ARROW_UP, action: () => {

                if (index === "cust_po") {
                    switchToCustomer()
                } else {
                    prev()
                }
            }
        },


    ];

    const pos_edit_nav = [
        { key: KBD.ESCAPE, action: () => cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT) },
        { text: "Cpy" },
        { key: KBD.V, text: "View" },
        { key: KBD.N, text: "New" },
        { text: "Del" },
        { key: KBD.E, text: "Edt" },
        { text: "@Edt" },

        { text: "GftRct" },
    ]


    return (
        <div>
            <div onClick={() => {
                if (state?.edit && window.bm_state.value === ROUTES.POS.CUSTOMER) {
                    switchToTransaction();
                }
            }} style={{ "padding": "0px 15px" }}>






                <Label style={{ "textAlign": "left" }}>&nbsp;Search Results:{index}</Label>
                <div className="shim" />
                <Space size={10} style={{ "alignItems": "start" }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>
                        <VirtualTable
                            row_height={26}
                            controller={controller}
                            onRowDoubleClick={(e) => testIt(e)}
                            onRowClick={(item, event, index) => {


                                setAlign("auto"); setSelected(item)
                            }}

                            next={nextItem}
                            prev={prevItem}
                            align={align}
                            row_key={"pos_id"}
                            current={(state.edit) ? selected : {}}
                            data={(state.edit) ? data.concat([{ pos_id: "" }]) : data}
                            height={251}
                            columns={columns}
                            width={0}
                            loading={loading}
                            offset={430}
                            route={route}
                            scrollbar={true}
                            scrollindicator={true}
                            infinite={true}
                        />
                    </div>
                    <Card header={<Label style={{ "textAlign": "left" }}>POS Transaction Log</Label>} style={{ "width": "282px" }} secondary>
                        <Label>POS Transaction Log</Label>
                    </Card>
                </Space>



            </div>
            {(state.adding || state.edit) && <>
                <div className="shim" />
                <Divider />
                <div style={{ 'height': "30px" }}>
                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={(state.adding) ? pos_new_nav : pos_edit_nav} />
                    </Space>
                </div>
            </>}

        </div>
    )
}